module.exports = __webpack_public_path__ + "img/logo-white.f8eb2c1b.svg";